import { Subject } from 'rxjs';

interface WindowAction {
	type: 'open' | 'close' | 'closeAll';
	payload?: {
		windowName: string;
		url?: string;
		target?: string;
		features?: string;
	};
}

const windowAction$ = new Subject<WindowAction>();

class WindowService {
	windows: { [key: string]: Window } = {};

	constructor() {
		windowAction$.subscribe((action: WindowAction) => {
			const { type, payload } = action;

			switch (type) {
				case 'open':
					if (payload) {
						const { windowName, url, target, features } = payload;
						if (url) {
							if (!this.windows[windowName] || this.windows[windowName].closed) {
								this.windows[windowName] = window.open(url, target, features)!;
							} else {
								this.windows[windowName].location.href = url;
								this.windows[windowName].focus();
							}
						}
					}
					break;
				case 'close':
					if (payload?.windowName) {
						const { windowName } = payload;
						const win = this.windows[windowName];
						if (win && !win.closed) {
							win.close();
							delete this.windows[windowName];
						}
					}
					break;
				case 'closeAll':
					Object.keys(this.windows).forEach((key) => {
						const win = this.windows[key];
						if (win && !win.closed) win.close();
					});
					this.windows = {};
					break;
			}
		});
	}

	/** 另開新視窗 (若視窗已存在, 更新其 url 並使其獲取焦點) */
	openWindow = (windowName: string, url: string, target = '', features = '') =>
		windowAction$.next({ type: 'open', payload: { windowName, url, target, features } });

	/** 關閉指定視窗 */
	closeWindow = (windowName: string) =>
		windowAction$.next({ type: 'close', payload: { windowName } });

	/** 關閉所有另開的視窗 */
	closeAllWindows = () => windowAction$.next({ type: 'closeAll' });
}

export const windowService = new WindowService();